import {UyapRequest} from "./UyapRequest";
import {ISorguSonuc} from "./CommonInterfaces"
import app from "@/main";

export interface DosyaBorcluSSKTalep {
    dosyaId: string | number,
    kisiKurumId: number
    sorguBakiye: number | string
}

export interface DosyaBorcluSSKCevap extends ISorguSonuc<IDosyaBorcluSSKSonuc>{}

export interface IDosyaBorcluSSKSonuc {
    sskBilgi: SskBilgi,
    isYeriBilgileri: IsYeriBilgileri,
    sskBilgiDetay: SskBilgiDetay
}

export interface SskBilgi {
    sonucKodu: number,
    tescilKaydi4AList: Array<TescilKaydi4Alist>,
    anaHataKodu: number
}

export interface TescilKaydi4Alist {
    kimlikBilgileri: KimlikBilgileri,
    kisiSonucKod: number,
    sicilNo: string
}

export interface KimlikBilgileri {
    ad: string,
    anneAdi: string,
    babaAdi: string,
    dogumTarihi: string,
    dogumYeri: string,
    dogumYili: string,
    durumKod: string,
    hataKodu: number,
    ilkSoyad: string,
    iseGirisTarihi: string,
    ittKodu: number,
    sicilNo: string,
    soyad: string,
    tcKimlikNo: string
}

export interface IsYeriBilgileri {
    data: Data,
    metadata: Metadata,
    isNew: boolean
}

interface Data {
    hataKodu: number,
    sonuc: Sonuc,
    isNew: boolean
}

interface Sonuc {
    basarili: string,
    hataKod: number,
    mesaj: string,
    isNew: boolean,
    isyeriTescil4AOzetArray?: Array<IsyeriTescil4AOzet>
}

interface IsyeriTescil4AOzet {
    teIlkod: number,
    teYeniSubeKod: number,
    teEskiSubeKod: number,
    teSirano: number,
    araciNo: number,
    unvan: string,
    teKankapckTar: string,
    teVergiNo: string,
    sonDonemYil: number,
    sonDonemAy: number,
    sonDonemHizmetGun: number,
    isNew: boolean
}

interface Metadata {
    FMTY: string,
    FMTE: string,
    FMC: string
}

export interface SskBilgiDetay {
    hasData: boolean,
    aktif: boolean,
    sgkIsyeriDVO: SgkIsyeriDvo,
    ilAdi: string,
    ilceAdi: string,
}

export interface SgkIsyeriDvo {
    sigortaliBilgi: SigortaliBilgi,
    hataKodu: number,
    hataMesaji: string
}

export interface SigortaliBilgi {
    ad: string,
    adres: string,
    anneAdi: string,
    babaAdi: string,
    checkDigit: string,
    dogumTarihi: string,
    dogumYeri: string,
    donemYilAy: string,
    durumKod: SigortaDurumKod,
    eski_sube_kod: string,
    ilKod: string,
    ilceKod: string,
    ilkIseGirisTarihi: string,
    ilkSoyad: string,
    isKoluKodu: string,
    istenCikisTarihi: string,
    isyeriAdresi: string,
    isyeriSicil: string,
    isyeriUnvan: string,
    mahiyet: string,
    mahiyetKod: string,
    sicilNo: string,
    siraNo: string,
    soyad: string,
    tcKimlikNo: string,
    yeni_sube_kod: string
}

export enum SigortaDurumKod {
    AKTIF = "A",
    PASIF = "T"
}



export class DosyaBorcluSSK extends UyapRequest<DosyaBorcluSSKTalep, DosyaBorcluSSKCevap> {
    delayTime=2000;

    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Dosya borçlu SSK bilgileri sorgulanıyor...";
    }


    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "DosyaBorcluSSK_" + app.$uyapHelper.hash(this.talepData)
        };
    }

    getMockResponse(): any {
        return {"borcluBilgileri":{"kisiTumDVO":{"olumKaydi":false,"isAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","sorguTuru":0,"tcKimlikNo":"4********10","adi":"AH**** MÜ***","soyadi":"YA*******","babaAdi":"A*********","anaAdi":"Ş*****","dogumTarihiStr":"1957","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false},"kisiKurumId":28698317,"turu":0},"sorgulayanBilgileri":"Av.NİHAN ERDOĞAN","portalTuru":2,"dosyaOzetDVO":{"birimDVO":{"birimAdi":"Ankara 2. Genel İcra Dairesi","birimId":"1000963","orgKodu":"1.04.011.000.6037","duzey1":"1","duzey2":"04","duzey3":"011","duzey4":"000","duzey5":"6037","birimTuru1":"11","birimTuru2":"1101","birimTuru3":"1199","evraginBirimDVODaGonderilecegiBirimBilgisi":0,"yeniBirimEkle":true,"orgKoduDegisti":false,"isTumunuKopyala":false,"eskiAd":"","eskiOrgKod":"","taranmamisKaydetme":"","testMi":0},"rolIdList":[],"isBirimKapali":false,"dosyaTurKod":35,"dosyaTurAd":"İcra Dosyası","dosyaNo":"2023/27440","dosyaNoYil":2023,"dosyaSira":27440,"dosyaId":"013@RlwAzAkR3QHUdOJ2IvK1AVcKDKKFQOTf7DmiWdYyAr3Da8QL8DHqX568MHRx","dosyaAcilisTarihi":"08/07/2023 10:35","genelDosyaDurumu":"Açık","genelDosyaDurumuAsInteger":0,"taraflar":"ABDULSELAM DENİZ, AHMETİ MÜNÜR YALÇINALP","vekilId":0,"vekilMi":false,"vekilHazineAvukatiMi":false},"sorguTarihi":"25/04/2024 13:07","sorguSonucDVO":{"sskBilgi":{"sonucKodu":0,"tescilKaydi4AList":[{"kimlikBilgileri":{"ad":"AHMETİ MÜNÜR","anneAdi":"sadıye","babaAdi":"ABDULKADIR","dogumTarihi":"25.08.1957","dogumYeri":"SIVAS","dogumYili":"1957","durumKod":"A","hataKodu":0,"ilkSoyad":"","iseGirisTarihi":"2002-01-26","ittKodu":0,"sicilNo":"5501200200516","soyad":"YALCINALP","tcKimlikNo":"47161224210"},"kisiSonucKod":0,"sicilNo":"5501200200516"}],"anaHataKodu":0},"isYeriBilgileri":{"data":{"hataKodu":0,"sonuc":{"basarili":"false","hataKod":6,"mesaj":"Bu yıl ve bir önceki yıl için 4a hizmet verisi bulunamadı.","isNew":true},"isNew":true},"metadata":{"FMTY":"SUCCESS","FMTE":"İşlem başarıyla gerçekleştirildi!","FMC":"ADALET_SUCCESS"},"isNew":true},"sskBilgiDetay":{"hasData":false,"aktif":false,"sgkIsyeriDVO":{"sigortaliBilgi":{"ad":"AHMETİ MÜNÜR","adres":"SAMSUN","anneAdi":"SADIYE","babaAdi":"ABDULKADIR","checkDigit":"14","dogumTarihi":"25.08.1957","dogumYeri":"SIVAS","donemYilAy":"2018/12","durumKod":"A","eski_sube_kod":"1","ilKod":"6","ilceKod":"21","ilkIseGirisTarihi":"2002-01-26","ilkSoyad":"","isKoluKodu":"1712","istenCikisTarihi":"20/12/2018","isyeriAdresi":"OSTİM OSB MAH.CEVAT DÜNDAR İŞ MERK 1246 CADDE 25 169 ANKARA YENİMAHALLE","isyeriSicil":"2-1712-01-01-1227578-006-21-14-000","isyeriUnvan":"YENİ KARE KARTON AMBALAJ ET.MAT.İTH.İHR.SAN.VE TİC.LTD.ŞTİ.","mahiyet":"KAĞIT VE MUKAVVA İML.","mahiyetKod":"2","sicilNo":"5501200200516","siraNo":"1227578","soyad":"YALCINALP","tcKimlikNo":"47161224210","yeni_sube_kod":"1"},"hataKodu":0,"hataMesaji":""},"ilAdi":"ANKARA","ilceAdi":"NALLIHAN"}},"sorgulamaTuru":"SSK Çalışanı","sorguSonucu":true,"hasError":false,"hasData":false,"isMock":false}
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'borclu_bilgileri_goruntule_sgk_sskCalisaniBilgileri.ajx';
    }


    async parse(data: any): Promise<DosyaBorcluSSKCevap> {
        data.message = "Sorgulama başarılı";
        return data;
    }
}

export default DosyaBorcluSSK;
